export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-gradient-to-br from-background-100 to-background-200/70 rounded-xl border border-background-200/60 p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/20 text-accent-400 border border-accent-500/30 mb-4">
              移动观影
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              手机观影 · 随时随地看大片
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-lg">
              97影视全面适配移动端，在手机上也能享受高清流畅的观影体验。支持横屏全屏播放，自适应网络环境智能调节画质，流量与WiFi环境下都能畅快观影。
            </p>
            <div className="flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 border border-background-300/60 rounded-md">
                <i className="ri-smartphone-line text-primary-500 text-lg" />
                <span className="text-xs text-foreground-600">iOS / Android 适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 border border-background-300/60 rounded-md">
                <i className="ri-fullscreen-line text-primary-500 text-lg" />
                <span className="text-xs text-foreground-600">横屏全屏播放</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 bg-background-50 border border-background-300/60 rounded-md">
                <i className="ri-speed-line text-primary-500 text-lg" />
                <span className="text-xs text-foreground-600">智能画质调节</span>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-48 h-80 rounded-2xl overflow-hidden border-2 border-background-300/60 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20a%20cinematic%20movie%20streaming%20app%20interface%20on%20dark%20theme%2C%20movie%20poster%20thumbnails%20grid%20layout%2C%20warm%20golden%20accent%20colors%20on%20dark%20background%2C%20minimal%20UI%20design%2C%20clean%20modern%20mobile%20app%20screen&width=480&height=800&seq=app-mobile-01&orientation=portrait"
                alt="97影视手机观影"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}